import { useEffect } from "react";

interface JsonLdProps {
  data: object | object[];
}

export default function JsonLd({ data }: JsonLdProps) {
  useEffect(() => {
    const scriptId = "json-ld-seo";
    const prev = document.getElementById(scriptId);
    if (prev) prev.remove();

    const script = document.createElement("script");
    script.id = scriptId;
    script.type = "application/ld+json";
    script.text = JSON.stringify(Array.isArray(data) ? data : [data]);
    document.head.appendChild(script);
    return () => {
      script.remove();
    };
  }, [data]);

  return null;
}